<template>
    <div>
        <button v-for="price in price" class="btn btn-secondary" type="button" id="0"><small class="border-bottom">Mon</small> <br> <small>Jun 2</small><br>$123</button>
<!--        {{price}}-->
    </div>
</template>

<script>
    export default {
        name: "DateWithPriceComponent",
        props:[
            'priceDate',
            'offerPricePercent',
        ],
        data() {
            return {
                DefaultTotalDays: 7,
                // price:this.price
            }
        },created() {
            console.log(this.priceDate)
            // console.log( JSON.parse(JSON.stringify(this.price)))
        }
    }
</script>

<style scoped>

</style>
